export const COOKIE_KEY_SHOP_SESSION = '_HEDVIG_SHOP_SESSION'
export const SHOP_SESSION_PROP_NAME = 'shopSessionId'
